export const setting = {
  blue: "#191970",
  orange: "orange",
  font: "Audiowide",
  white: "#fff",
  black: "#000",
};
